import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import Dashboard from "@mui/icons-material/Dashboard";
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import { useUserContext } from "../contexts/UserContext";
import p from "../../package.json";

export default function BottomNavigator() {
    const navigate = useNavigate();
    const location = useLocation();
    const { user } = useUserContext();

    const showManage = user?.entities?.length > 0;

    const value = location.pathname.startsWith("/manage")
        ? "manage"
        : location.pathname.startsWith("/scan")
        ? "scan"
        : "dashboard";

    const handleChange = (_event, newValue) => {
        if (newValue === "scan") {
            navigate("/scan");
        } else if (newValue === "manage") {
            navigate("/manage");
        } else {
            navigate("/");
        }
    };

    return (
        <>
            <BottomNavigation
                sx={{ position: "fixed", bottom: 0, left: 0, right: 0 }}
                elevation={3}
                value={value}
                onChange={handleChange}
                showLabels={true}
            >
                <BottomNavigationAction label="Dashboard" value="dashboard" icon={<Dashboard />} />
                <BottomNavigationAction label="Scan" value="scan" icon={<QrCodeScannerIcon />} />
                {showManage && <BottomNavigationAction label="Manage" value="manage" icon={<ManageAccountsIcon />} />}
            </BottomNavigation>
            <div
                style={{
                    position: "absolute",
                    bottom: 0,
                    right: 0,
                    color: "#aaa",
                    fontSize: "8px",
                    marginRight: "10px",
                }}
            >
                v{p.version}
            </div>
        </>
    );
}
